export default __webpack_public_path__ + "static/media/blog-img.8757c2bd.png";